// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.descFormato {
  color: #3a7be0;
}

.input-readonly {
  color: gray;
  opacity: 0.75;
}

.qta-avanzamento-value {
  text-align: right;
}
.qta-avanzamento-value::part(native) {
  text-align: right;
  padding-inline-end: 2rem;
}

.ordine-tabs-segment ion-segment-button {
  flex: 0 0 auto;
  min-width: max-content;
  white-space: nowrap;
}

.ordine-tempo-loading {
  position: sticky;
  top: 0;
  z-index: 20;
  overflow: hidden;
  margin: 8px;
  border-radius: 8px;
  background: var(--ion-color-step-50, rgba(255, 255, 255, 0.96));
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}

.ordine-tempo-loading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ordini-update-send/ordini-update-send.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;AACF;;AAOA;EACE,iBAAA;AAJF;AAME;EACE,iBAAA;EACA,wBAAA;AAJJ;;AAYE;EACE,cAAA;EACA,sBAAA;EACA,mBAAA;AATJ;;AAaA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,+DAAA;EACA,0CAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAVF","sourcesContent":[".descFormato {\n  color: #3a7be0;\n}\n\n.input-readonly {\n  color: gray;\n  opacity: 0.75;\n}\n\n// Conforme/Scartata/Non conforme: l'input resta flex:1 (larghezza automatica, responsive) come\n// prima; il testo allineato a destra fa terminare i 3 numeri sullo stesso bordo. Il padding-right\n// li stacca da quel bordo (spostandoli a sinistra, verso la label) senza bisogno di larghezze\n// fisse: niente rotture su schermi stretti (tablet/telefono), a differenza di un tentativo\n// precedente con labelPlacement=\"fixed\" + larghezza fissa che troncava le label e nascondeva i valori.\n.qta-avanzamento-value {\n  text-align: right;\n\n  &::part(native) {\n    text-align: right;\n    padding-inline-end: 2rem;\n  }\n}\n\n// Su schermi stretti 5 tab non ci stanno: [scrollable]=\"true\" (nel markup) rende il segment\n// scorrevole invece di schiacciare/troncare il testo dei tab. flex:0 0 auto impedisce che i\n// singoli ion-segment-button si riducano comunque a forzare il testo in ellissi.\n.ordine-tabs-segment {\n  ion-segment-button {\n    flex: 0 0 auto;\n    min-width: max-content;\n    white-space: nowrap;\n  }\n}\n\n.ordine-tempo-loading {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  overflow: hidden;\n  margin: 8px;\n  border-radius: 8px;\n  background: var(--ion-color-step-50, rgba(255, 255, 255, 0.96));\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);\n}\n\n.ordine-tempo-loading-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 10px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
